module.exports = __webpack_public_path__ + "static/media/fac8.e56a5f1e.jpg";